module.exports = {"embedded":"true","defaultView":"Exterior"}